// @ts-nocheck
// ====== UI polish helpers ======
// Funzioni di rifinitura UX riusabili da altri moduli:
//   - skeletonRows(tbodyEl, cols, rows)  : righe placeholder durante caricamento
//   - emptyState(tbodyEl, cols, opts)    : empty state con icona e CTA
//   - showInlineError(viewId, msg, opts) : banner errore persistente con retry

function skeletonRows(tbody, cols = 5, rows = 6) {
  if (!tbody) return;
  const tr = [];
  for (let i = 0; i < rows; i++) {
    const cells = [];
    for (let j = 0; j < cols; j++) {
      cells.push(
        `<td><span class="skeleton skeleton-block" style="width:${50 + Math.random() * 40}%; height:14px;"></span></td>`
      );
    }
    tr.push(`<tr aria-hidden="true">${cells.join('')}</tr>`);
  }
  tbody.innerHTML = tr.join('');
}

function emptyState(tbody, cols, opts) {
  if (!tbody) return;
  const o = opts || {};
  tbody.innerHTML = `
    <tr>
      <td colspan="${cols}">
        <div class="empty-state">
          <svg class="empty-state-ico" viewBox="0 0 64 64" aria-hidden="true">
            <circle cx="32" cy="32" r="28" fill="none" stroke="currentColor" stroke-width="2" opacity="0.35"/>
            <path d="M22 28h20M22 36h12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" opacity="0.6"/>
            <circle cx="44" cy="44" r="8" fill="none" stroke="currentColor" stroke-width="2.4"/>
            <path d="M50 50l6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
          </svg>
          <div class="empty-state-title">${escapeHtml(o.title || 'Nessun risultato')}</div>
          ${o.message ? `<div class="empty-state-msg">${escapeHtml(o.message)}</div>` : ''}
          ${o.ctaLabel && o.onCta ? `<button class="btn btn-primary btn-sm" data-empty-cta>${escapeHtml(o.ctaLabel)}</button>` : ''}
        </div>
      </td>
    </tr>`;
  if (o.onCta) {
    tbody.querySelector('[data-empty-cta]')?.addEventListener('click', o.onCta);
  }
}

// Inline error banner: appare in cima alla vista (#view-<id>), persistente,
// con bottone Riprova opzionale.
function showInlineError(viewId, message, opts) {
  const o = opts || {};
  const view = document.getElementById('view-' + viewId);
  if (!view) return;
  removeInlineError(viewId);
  const banner = document.createElement('div');
  banner.className = 'inline-error';
  banner.id = 'inlineError-' + viewId;
  banner.setAttribute('role', 'alert');
  banner.innerHTML = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="13"/>
      <circle cx="12" cy="16.5" r="0.9" fill="currentColor"/>
    </svg>
    <div class="inline-error-text">
      <strong>${escapeHtml(o.title || 'Si è verificato un errore')}</strong>
      <div>${escapeHtml(message || '')}</div>
    </div>
    <div class="inline-error-actions">
      ${o.onRetry ? '<button class="btn btn-sm" data-retry>Riprova</button>' : ''}
      <button class="btn btn-sm" data-dismiss aria-label="Chiudi">Chiudi</button>
    </div>`;
  view.insertBefore(banner, view.firstChild);
  banner.querySelector('[data-dismiss]')?.addEventListener('click', () => banner.remove());
  banner.querySelector('[data-retry]')?.addEventListener('click', async () => {
    banner.remove();
    try {
      await o.onRetry();
    } catch (e) {
      showInlineError(viewId, e.message || String(e), opts);
    }
  });
}

function removeInlineError(viewId) {
  document.getElementById('inlineError-' + viewId)?.remove();
}

// ===== G5: Skeleton globale al routing =====
// Mostra un placeholder generico mentre lo switch di view sta renderizzando.
// Usato dal router: showViewSkeleton('clienti') subito dopo `setView`.
function showViewSkeleton(viewId, opts = {}) {
  const view = document.getElementById('view-' + viewId);
  if (!view) return;
  if (view.querySelector('.view-skeleton')) return;
  const sk = document.createElement('div');
  sk.className = 'view-skeleton';
  const rows = opts.rows || 4;
  sk.innerHTML = `
    <div class="sk-bar lg"></div>
    <div class="sk-grid">
      ${'<div class="sk-card"></div>'.repeat(4)}
    </div>
    ${'<div class="sk-bar md"></div><div class="sk-bar sm"></div>'.repeat(rows)}`;
  view.insertBefore(sk, view.firstChild);
  // Rimuovi automaticamente dopo timeout sicuro (max 4s) — il render reale lo
  // sostituisce di solito prima.
  const timeout = setTimeout(() => sk.remove(), opts.maxMs || 4000);
  sk.__timeout = timeout;
}
function hideViewSkeleton(viewId) {
  const view = document.getElementById('view-' + viewId);
  if (!view) return;
  view.querySelectorAll('.view-skeleton').forEach((sk) => {
    if (sk.__timeout) clearTimeout(sk.__timeout);
    sk.remove();
  });
}

// ===== G4: Empty state helper riusabile (per altri container, non solo tbody) =====
function emptyStateBlock(container, opts = {}) {
  if (!container) return;
  const o = opts;
  const iconSvg =
    o.iconSvg ||
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" class="empty-state-icon" aria-hidden="true">
      <circle cx="12" cy="12" r="10"/>
      <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
      <line x1="9" y1="9" x2="9.01" y2="9"/>
      <line x1="15" y1="9" x2="15.01" y2="9"/>
    </svg>`;
  container.innerHTML = `<div class="empty-state">
    ${iconSvg}
    <h4>${escapeHtml(o.title || 'Niente da mostrare')}</h4>
    ${o.message ? `<p>${escapeHtml(o.message)}</p>` : ''}
    ${o.ctaLabel && o.onCta ? `<button class="btn btn-primary btn-sm" data-empty-cta>${escapeHtml(o.ctaLabel)}</button>` : ''}
  </div>`;
  if (o.onCta) container.querySelector('[data-empty-cta]')?.addEventListener('click', o.onCta);
}

Object.assign(globalThis, {
  skeletonRows,
  emptyState,
  emptyStateBlock,
  showInlineError,
  removeInlineError,
  showViewSkeleton,
  hideViewSkeleton
});
export {};
